export function scrollToCat(offset: number): void {
  setTimeout(() => {
    document.getElementById('tender')?.scrollTo({ behavior: 'smooth', top: offset });
  }, 100);
}
export function closestIndex(number: number, array: number[]): number {
  let mid: number;
  let lo = 0;
  let hi = array.length - 1;
  while (hi - lo > 1) {
    mid = Math.floor((lo + hi) / 2);
    if (array[mid] < number) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  if (number - array[lo] <= array[hi] - number) {
    return lo;
  }
  return hi;
}
